import React, { useEffect, useState } from 'react';
import './dashboard-team.container.sass';
import { useDispatch, useSelector } from 'react-redux';
import { getTeamVendorId } from '../../login/session.slice';
import { Button, ButtonSize, ButtonType } from '../../../components/interface/button/button';
import { AddUserToTeamModal } from './component/add-user-to-team-modal/add-user-to-team.modal';
import { TableRow } from '../../../components/interface/table/tableRow';
import { getTeamUsers } from './dashboard-team.slice';
import { RemoveUserModal } from './component/remove-user-modal/remove-user.modal';
import { Dropdown, DropdownSize } from '../../../components/interface/input/dropdown/dropdown';

const TeamMemberStatus = {
  'ACTIVE': 1,
  'INVITED': 0
};

const isVerifiedStatuses = {
  [TeamMemberStatus.INVITED]: 0,
  [TeamMemberStatus.ACTIVE]: 1
};

export const DashboardTeamContainer = () => {

  const dispatch = useDispatch();
  const [isAddTeamUserModalVisible, setIsAddTeamUserModalVisible] = useState(false);
  const [isDeleteUserModalVisible, setIsDeleteUserModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState();
  const sessionData = useSelector(state => state.session);
  const dashboardTeamData = useSelector(state => state.dashboardTeam);
  const users = dashboardTeamData.users || [];
  const vendorId = getTeamVendorId(sessionData);

  useEffect(() => {
    dispatch(getTeamUsers({vendorId}));
  }, []);

  const statusOptions = [{value: TeamMemberStatus.INVITED, label: 'Zaproszono'}, {value: TeamMemberStatus.ACTIVE, label: 'Aktywna'}, {label: 'Wszystkie'}];

  const renderRow = (e, i) => {
    return <TableRow classNames='vv-dashboard-team-container-row' key={i}>
      <div data-flex={1}>
        <span className='vv-dashboard-team-container-row__name'>{`${e?.user?.first_name}`}</span>
      </div>
      <div data-flex={1}>
        <span>{e?.user?.email}</span>
      </div>
      <div data-flex={1}>
        <span>{new Date(e?.join_date).toLocaleDateString()}</span>
      </div>
      <div data-flex={1}>
        <span className={`vv-dashboard-team-container-row__${e.is_verified ? 'active' : 'inactive'}`}>{e.is_verified ? 'Aktywna' : 'Zaproszono'}</span>
      </div>
      <div data-flex={1}>
        <Button text='USUN' buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.SMALL} onClick={() => {
          setSelectedUserId(e?.user.id);
          setIsDeleteUserModalVisible(true);
        }}/>
      </div>
    </TableRow>;
  };

  const renderHeader = () => {
    return <TableRow header classNames='vv-dashboard-team-container-header'>
      <div data-flex={1}>
        <span>Imię i nazwisko</span>
      </div>
      <div data-flex={1}>
        <span>Email</span>
      </div>
      <div data-flex={1}>
        <span>Data dołączenia</span>
      </div>
      <div data-flex={1}>
        <span>Status</span>
      </div>
      <div data-flex={1}>
        <span>Akcja</span>
      </div>
    </TableRow>;
  };

  const getUsers = (status) => {
    let filter = undefined;
    if (isVerifiedStatuses[status] !== undefined) {
      filter = { is_verified: status };
    }
    dispatch(getTeamUsers({vendorId: getTeamVendorId(sessionData), filter: filter}));
  };

  return (
   <div className='vv-dashboard-team-container'>
     <h2>Personel</h2>
     <div className='vv-dashboard-team-container__dropdown'>
       <Dropdown name='status' id='status' label='Status' options={statusOptions} onChange={(option) => getUsers(option.value)} size={DropdownSize.SMALL} placeholder='Wszystkie'/>
     </div>
     <div className='vv-dashboard-team-container__table-container'>
       {renderHeader()}
       {Array.isArray(users) && users.map(renderRow)}
     </div>
     <div className='vv-dashboard-team-container__button-container'>
       <Button text='dodaj' buttonType={ButtonType.BLACK} onClick={() => setIsAddTeamUserModalVisible(true)}/>
     </div>
     <AddUserToTeamModal isVisible={isAddTeamUserModalVisible} setIsVisible={setIsAddTeamUserModalVisible} vendorId={vendorId}/>
     <RemoveUserModal userId={selectedUserId} vendorId={vendorId} isVisible={isDeleteUserModalVisible} setIsVisible={setIsDeleteUserModalVisible}/>
   </div>
  );
};
